/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa3ac1cb079d613c521a1d89096297a4>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const MergeFailureIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "MergeFailureIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
MergeFailureIcon.displayName = 'MergeFailureIcon';
var _default = exports.default = MergeFailureIcon;